module.exports = "/_next/static/images/876729aeadd084b02107b55b2a417035-locked-deposits@3x.jpg.webp";